export function searchObjectProperties(obj, searchString) {
  let lowerCaseSearchString = searchString.toLowerCase();
  return Object.values(obj).some((value) => {
    if (Array.isArray(value)) {
      return value.some((item) => {
        if (typeof item === "string")
          return item.toLowerCase().includes(lowerCaseSearchString);
        else if (typeof item === "number")
          return item.toString().toLowerCase().includes(lowerCaseSearchString);
        else if (typeof item === "object" && item !== null) {
          return Object.values(item).some(
            (item2) =>
              typeof item2 === "string" &&
              item2.toLowerCase().includes(lowerCaseSearchString)
          );
        }
      });
    } else if (typeof value === "string") {
      return value.toLowerCase().includes(lowerCaseSearchString);
    } else if (typeof value === "number") {
      return value.toString().toLowerCase().includes(lowerCaseSearchString);
    } else if (typeof value === "object" && value !== null) {
      return Object.values(value).some(
        (item) =>
          typeof item === "string" &&
          item.toLowerCase().includes(lowerCaseSearchString)
      );
    }
    return false;
  });
}
//check if the entity is admin in any of the tools
export function getIsAdminList(row) {
  if (row.admin_roles && typeof row.admin_roles === "object") {
    return Object.keys(row.admin_roles).filter(
      (platform) =>
        row.admin_roles[platform] && row.admin_roles[platform].length > 0
    );
  }

  return [];
}

export function getUserLastActiveTimestamp(row) {
  // Check unified last_seen field first
  if (row?.last_seen && typeof row.last_seen === "object") {
    const lastSeenValues = Object.values(row.last_seen);
    let maxTimestamp = 0;
    for (const value of lastSeenValues) {
      const timestamp =
        typeof value === "object" && value?.timestamp_utc
          ? value.timestamp_utc
          : typeof value === "number"
          ? value
          : 0;
      if (timestamp > maxTimestamp) {
        maxTimestamp = timestamp;
      }
    }
    if (maxTimestamp > 0) {
      return maxTimestamp;
    }
  }
  return null;
}

export function getUserTerminationTimestamp(entity) {
  const hibobTerminationDate =
    entity?.hibob_data?.termination_date?.timestamp_utc;
  const bamboohrTerminationDate =
    entity?.bamboohr_data?.termination_date?.timestamp_utc;
  return hibobTerminationDate || bamboohrTerminationDate || null;
}

export function getHostLastSeenTimestamp(row) {
  const sources = [
    ["crowdstrike_data", "last_seen"],
    ["jamf_data", "last_seen"],
    ["jamf_protect_data", "last_seen"],
    ["intune_data", "last_sync_date"],
    ["microsoft_entra_id_data", "last_seen"],
    ["okta_data", "last_updated_date"],
    ["zscaler_zcc_data", "last_seen_time"],
    ["paloalto_cortex_xdr_data", "last_seen"],
    ["microsoft_defender_data", "last_seen"],
    ["addigy_data", "last_seen"],
    ["paloalto_talon_data", "last_seen"],
    ["paloalto_prisma_access_browser_data", "last_seen"],
    ["sentinel_one_data", "last_seen"],
    ["netskope_data", "last_seen"],
    ["ninjaone_data", "last_seen"],
    ["cloudflare_ztna_data", "last_seen_at"],
    ["kandji_data", "last_seen_date"],
    ["microsoft_sccm_data", "last_seen"],
    ["cato_data", "last_connected"],
  ];

  let lastSeenTimestamp = 0;

  for (const source of sources) {
    if (Array.isArray(source)) {
      const sourceTimestamp = row?.[source[0]]?.[source[1]]?.timestamp_utc;
      if (sourceTimestamp && sourceTimestamp > lastSeenTimestamp)
        lastSeenTimestamp = sourceTimestamp;
    } else {
      const sourceTimestamp = row?.[source]?.timestamp_utc;
      if (sourceTimestamp && sourceTimestamp > lastSeenTimestamp)
        lastSeenTimestamp = sourceTimestamp;
    }
  }
  if (lastSeenTimestamp === 0) return null;
  return lastSeenTimestamp;
}
